import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfPersonasEmpleadosHorarios } from '@/modules/Administracion/interfaces'
import type { IResponseApi, IResponseApiSearch } from '@/modules/Core/interfaces'
import type { AxiosResponse } from 'axios'
import type { tipoGeneralesHorarios } from '@/modules/Administracion/interfaces/tablas/IConfPersonas'
import type { IAssignScheduleToEmployees } from '../interfaces/tablas/IConfPersonasEmpleadosHorarios'
export class HorarioService extends BaseService<IConfPersonasEmpleadosHorarios> {
  constructor() {
    super({
      baseUrl: 'system/schedules/'
    })
  }
  async searchHorario(
    id: number | string,
    params?: Record<string, unknown>
  ): Promise<
    AxiosResponse<IResponseApiSearch<IConfPersonasEmpleadosHorarios[]>>
  > {
    return this.http
      .get<
        IResponseApiSearch<IConfPersonasEmpleadosHorarios[]>
      >(`/search/${id}`, { params })
      .catch(this.errorHandle)
  }
  async asignarHorarioToEmpleados(
    employeeId: number,
    payload: IAssignScheduleToEmployees
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http
      .post<
        IResponseApi<string>
      >(`/assignScheduleToEmployees/${employeeId}`, payload)
      .catch(this.errorHandle)
  }
  async getGenerales(): Promise<
    AxiosResponse<IResponseApi<tipoGeneralesHorarios>>
  > {
    return this.http.get<IResponseApi<tipoGeneralesHorarios>>(
      `/general-schedules`
    )
  }
}
